export default "__VITE_ASSET__Cbr5$R9C__"